import Pluralize from "react-pluralize";
import ProfileIcon from "../../../shared/ProfileIcon";
import Linkify from "linkify-react";
import IconButton from "@shared/v2/IconButton";
import { CheckSolidV6, Trash } from "@shared/v2/Icomoon";
import Modal from "@shared/v2/Modal";
import Button from "@shared/v2/Button";
import AppointmentDueDate from "./AppointmentDueDate";
import CardDetail from "./CardDetail";

const WEEKLY_OPTIONS = [
  { value: 0, label: "On Sunday" },
  { value: 1, label: "On Monday" },
  { value: 2, label: "On Tuesday" },
  { value: 3, label: "On Wednesday" },
  { value: 4, label: "On Thursday" },
  { value: 5, label: "On Friday" },
  { value: 6, label: "On Saturday " },
];

const Details = ({
  task,
  editTask,
  completeTaskFromDetails,
  openComplete,
  onDelete,
  closeTaskDetails,
  type = "Appointment",
}) => (
  <Modal
    id="task-details"
    className="person-details-modal"
    show
    onHide={closeTaskDetails}
    dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
    contentClassName="tw-max-w-[640px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
  >
    <Modal.Header title={`${type} Details`} closeButton />

    <Modal.Body className="tw-flex tw-overflow-hidden">
      <div className="tw-flex-1 tw-basis-5/12">
        <CardDetail isModal title="Date Due" />

        <AppointmentDueDate
          dueness={task.dueness}
          dueDate={task.calculated_due_on || task.due_on}
          scheduledTime={task.scheduled_time}
          preferScheduledTime
        />

        <CardDetail isModal customClassName="tw-pt-[16px]" title="Assignee" />

        {task.assigned_to_user_id && (
          <div className="clearfix contact-card !tw-mt-[2px]">
            <ProfileIcon dynamic={true} userId={task.assigned_to_user_id} showName={true} />
          </div>
        )}
        {!task.assigned_to_user_id && <p>Anyone</p>}
        <CardDetail isModal customClassName="tw-pt-[16px]" title="Priority" value={task.priority} />

        {!task.priority && <p>Unprioritized</p>}
        <CardDetail isModal customClassName="tw-pt-[16px]" title="Type" value={task.type} />

        {!task.assigned_plan_id && <CardDetail isModal customClassName="tw-pt-[16px]" title="Recurrence" />}

        {!task.assigned_plan_id && task.recurring && task.recurring_day_of_week && (
          <p>
            <i className="fa fa-refresh" style={{ marginRight: "10px" }} />
            {WEEKLY_OPTIONS[task.recurring_day_of_week]?.label}
          </p>
        )}

        {!task.assigned_plan_id && task.recurring && task.recurring_every_so_many_days && (
          <p>
            <i className="fa fa-refresh" style={{ marginRight: "10px" }} />
            Every <Pluralize singular={"day"} count={task.recurring_every_so_many_days} />
          </p>
        )}

        {!task.assigned_plan_id && !task.recurring && (
          <p>
            <i className="fa fa-refresh text-muted p-r-5" />
            Only once
          </p>
        )}
      </div>
      <div className="tw-flex-1 tw-basis-1/2 tw-break-all tw-overflow-auto">
        <CardDetail isModal title="Task Details" />
        <p>
          {task.assigned_plan_id && (
            <span>
              <i className={`fa fa-bolt m-r-5`} style={{ color: "#59c4c4" }} />
            </span>
          )}
          {task.name}
        </p>
        {task.instructions && (
          <div className="tw-whitespace-pre-wrap tw-break-words">
            <CardDetail isModal customClassName="tw-pt-[16px]" title="Instructions" />

            <Linkify tagName="p" options={{ defaultProtocol: "https", target: "_blank" }}>
              {task.instructions}
            </Linkify>
          </div>
        )}
        {task.note && (
          <div className="tw-whitespace-pre-wrap tw-break-words">
            <CardDetail isModal customClassName="tw-pt-[16px]" title="Notes" />

            <Linkify tagName="p" options={{ defaultProtocol: "https", target: "_blank" }}>
              {task.note}
            </Linkify>
          </div>
        )}
      </div>
    </Modal.Body>
    <Modal.Footer className="tw-flex tw-justify-between tw-gap-[16px]">
      <Button size="medium" schema="tertiary" onClick={closeTaskDetails}>
        Close
      </Button>
      <div className="tw-flex tw-gap-[4px]">
        {task.type === "Appointment" && (
          <IconButton className="tw-mt-[3px]" size="medium" schema="tertiary" onClick={() => onDelete(task)}>
            <Trash />
          </IconButton>
        )}
        <Button size="medium" onClick={() => editTask(task)}>
          Edit
        </Button>

        <Button
          size="medium"
          disabled={task.state === "completed"}
          onClick={
            task.type === "Appointment" ? () => openComplete(task) : () => completeTaskFromDetails(task)
          }
        >
          {task.state === "completed" ? (
            <>
              Appointment completed <CheckSolidV6 />
            </>
          ) : (
            `Complete ${type}`
          )}
        </Button>
      </div>
    </Modal.Footer>
  </Modal>
);

export default Details;
